export default __webpack_public_path__ + "static/media/logo.40497b36.png";